import React, { useEffect, useState } from 'react'
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector, useStore } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { getNotificationId, getNotificationQueryId } from '../../utils/adminNotificationUtils';
import { getApplicationCallMe, searchApplicationCallMe, deleteApplicationCallMeById, updateApplicationCallMeStatus, deleteManyApplicationCallMe } from '../../actions';
import { MainContainer } from '../MainContainer';
import { getItemById } from '../../actions/mainActions/mainAction';
import RenderDetailsModalCallMe from './RenderDetailsModalCallMe';
import AlertComponent from '../../components/Alert/Alert';
import { setCloseAlertApplication } from '../../reducers/application.reducer';
import { RenderItems } from './RenderItems';

const ApplicationsCallMe = () => {
    const location = useLocation();
    const store = useStore();
    const notificationApplicationId = getNotificationQueryId(location.search, "notificationApplicationId");
    const [notificationApplication, setNotificationApplication] = useState(null);
    const [notificationLoading, setNotificationLoading] = useState(false);
    const [notificationReload, setNotificationReload] = useState(0);
    const {
        applicationsCallMe, applicationCallMeObj, showAlert, variantAlert, message, loading
    } = useSelector(state => state.applicationCallMe);
    const { user } = useSelector(state => state.auth);

    const [showDetailsModal, setApplicationDetailModal] = useState(false);
    const [typeModal, setTypeModal] = useState("");
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [type, setType] = useState("")

    const dispatch = useDispatch()

    useEffect(() => {
        if (!notificationApplicationId) dispatch(getApplicationCallMe())
    }, [dispatch, notificationApplicationId])

    useEffect(() => {
        if (!notificationApplicationId) return undefined;
        let active = true;
        setNotificationLoading(true);
        Promise.resolve(dispatch(getItemById("applicationCallMe", notificationApplicationId))).then(() => {
            if (!active) return;
            const state = store.getState().applicationCallMe;
            const item = getNotificationId(state.applicationCallMeObj) === notificationApplicationId
                ? state.applicationCallMeObj : (state.applicationsCallMe || []).find((row) => getNotificationId(row) === notificationApplicationId);
            setNotificationApplication(item || null);
            setNotificationLoading(false);
        }).catch(() => {
            if (active) {
                setNotificationApplication(null);
                setNotificationLoading(false);
            }
        });
        return () => { active = false; };
    }, [dispatch, store, notificationApplicationId, notificationReload]);

    const focusedApplication = notificationApplicationId && getNotificationId(applicationCallMeObj) === notificationApplicationId ? applicationCallMeObj
        : getNotificationId(notificationApplication) === notificationApplicationId ? notificationApplication : null;
    const visibleApplications = notificationApplicationId ? focusedApplication ? [focusedApplication] : [] : applicationsCallMe;

    const showModal = (id) => {
        if (selectedItemId === id) {
            setSelectedItemId(null);
        } else {
            setSelectedItemId(id);
            dispatch(getItemById("applicationCallMe", id));
        }

        setApplicationDetailModal(true);
    };
    const handleClose = () => {
        setApplicationDetailModal(false);
        setTypeModal("")
    };
    const handleDeleteById = () => {
        dispatch(deleteApplicationCallMeById(applicationCallMeObj._id))
        setApplicationDetailModal(false)
    }
    const handleUpdateStatus = (id) => {
        const payload = {
            applicationCallMeId: id,
            type
        }
        dispatch(updateApplicationCallMeStatus(payload)).then(() => (
            dispatch(getApplicationCallMe())
        ))
    }

    return (
        <MainContainer
            offAll={!!notificationApplicationId}
            backButtonProduct
            type
            backHref
            search={searchApplicationCallMe}
            get={getApplicationCallMe}
            title={"Запрос обратного звонка"}
        >
            {notificationApplicationId && (
                <div className="admin-notification-target">
                    <span>{notificationLoading ? "Загрузка заявки…" : focusedApplication ? "Показана заявка из уведомления" : "Не удалось загрузить заявку"}</span>
                    {!notificationLoading && !focusedApplication && <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setNotificationReload((value) => value + 1)}>Повторить</button>}
                    <Link to="/applicationsCallMe">Все заявки на звонок</Link>
                </div>
            )}
            <Row style={{ marginTop: "15px" }}>
                <Col>
                    <RenderItems
                        applicationsCallMe={visibleApplications}
                        setTypeModal={setTypeModal}
                        showModal={showModal}
                        deleteDispatch={deleteManyApplicationCallMe}
                    />
                </Col>
            </Row>
            <RenderDetailsModalCallMe
                handleUpdateStatus={handleUpdateStatus}
                role={user.role}
                setType={setType}
                handleClose={handleClose}
                typeModal={typeModal}
                item={notificationApplicationId ? focusedApplication || {} : applicationCallMeObj}
                handleDeleteById={handleDeleteById}
                showDetailsModal={showDetailsModal}
            />
            <AlertComponent
                dispatchCloseAlert={setCloseAlertApplication}
                color={variantAlert}
                showObj={showAlert}
                text={message}
            />
        </MainContainer>
    )
}

export default ApplicationsCallMe
